import { FieldType, DefaultFormTableSchema } from "./types";
export class HouseOwnerSchema extends DefaultFormTableSchema {
    constructor() {
        super({
            columnData: {
                dateOfBirth: {
                    fieldType: FieldType.Date
                },
                isNorwegianCitizen: {
                    fieldType: FieldType.Checkbox
                },
                isResident: {
                    fieldType: FieldType.Checkbox
                },
                displayValue: {
                    fieldType: FieldType.Text
                }
            }
        });
    }
}
export class ApplicationCustomerAsHouseOwnerSchema extends DefaultFormTableSchema {
    constructor() {
        super({
            columnData: {
                personalNumber: {
                    fieldType: FieldType.Text
                },
                phone: {
                    fieldType: FieldType.Text
                },
                isResident: {
                    fieldType: FieldType.Checkbox
                }
            }
        });
    }
}
//# sourceMappingURL=HouseOwnerSchema.js.map